import { createSlice } from "@reduxjs/toolkit";
import { addMemberAPI, addSellerMemberAPI, editMemberAPI, editSellerMemberAPI, getMemberAPI, getSellerMemberAPI } from "../helpers/teamAPI";

const initialState = {
  teamMemberData: [],
};

export const teamMemberSlice = createSlice({
  name: "teamMember",
  initialState,
  reducers: {
    resetStateTeam: (state, action) => {
      state = initialState;
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addMemberAPI.fulfilled, (state, action) => {
        console.log("addMemberAPI", action);
        // state.types = action?.payload?.data;
      })
      .addCase(addMemberAPI.rejected, (state, action) => {
        console.log("addMemberAPI", action);
        // state.types = action?.payload?.data;
      })
      .addCase(addSellerMemberAPI.fulfilled, (state, action) => {
        console.log("addMemberAPI", action);
        // state.types = action?.payload?.data;
      })
      .addCase(addSellerMemberAPI.rejected, (state, action) => {
        console.log("addMemberAPI", action);
        // state.types = action?.payload?.data;
      })
      .addCase(editMemberAPI.fulfilled, (state, action) => {
        console.log("editMemberAPI", action);
      })
      .addCase(editMemberAPI.rejected, (state, action) => {
        console.log("editMemberAPI", action);
      })
      .addCase(editSellerMemberAPI.fulfilled, (state, action) => {
        console.log("editMemberAPI", action);
      })
      .addCase(editSellerMemberAPI.rejected, (state, action) => {
        console.log("editMemberAPI", action);
      })
      .addCase(getMemberAPI.fulfilled, (state, action) => {
        console.log("getMemberAPI", action);
        state.teamMemberData = action?.payload?.data;
      })
      .addCase(getMemberAPI.rejected, (state, action) => {
        console.log("getMemberAPI", action);
        state.teamMemberData = [];
      })
      .addCase(getSellerMemberAPI.fulfilled, (state, action) => {
        state.teamMemberData = action?.payload?.data;
      })
      .addCase(getSellerMemberAPI.rejected, (state, action) => {
        state.teamMemberData = [];
      });
  },
});

export const { resetStateTeam } = teamMemberSlice.actions;

export default teamMemberSlice.reducer;
